import { EpicGamesFooter } from '@wf-components/footer-react';
import { LOCALE_TO_COUNTRY_MAP } from '@constants/i18n';

interface Props {
  locale: string;
}

export const Footer = ({ locale }: Props): JSX.Element | null => {
  const countryCode = LOCALE_TO_COUNTRY_MAP[locale];

  return (
    <div id="footer">
      <EpicGamesFooter locale={locale} countryCode={countryCode} />
    </div>
  );
};
